import type { ActivityBootstrap } from "@tribe/domain";

/**
 * Who lives where, built from the bootstrap rather than from a table kept here.
 *
 * This used to be a hardcoded map of the twelve demo members, which meant that in a real guild
 * every plot in the village and every member-search result read "Tribe member" — the one thing a
 * village of named neighbours cannot afford. The Worker now sends each neighbour's display name,
 * so the lookup is derived from what arrived instead of guessed.
 */
export function buildOwnerNames(data: ActivityBootstrap): Map<string, string> {
  const names = new Map<string, string>();
  names.set(data.member.id, data.member.displayName);
  for (const neighbour of data.neighbours) names.set(neighbour.memberId, neighbour.displayName);
  return names;
}

/** The name for a plot's owner. An unassigned plot is ground, not a person. */
export function ownerNameFrom(names: Map<string, string>, ownerId: string | null): string {
  if (!ownerId) return "Available plot";
  return names.get(ownerId) ?? "Tribe member";
}
